import React from 'react'
import PropTypes from 'prop-types'
import PersonalInformationForm from './PersonalInformationForm'
import withOnboardingSection from 'components/Onboarding/withOnboardingSection'
import { mapPersonalInformationValues } from 'utils/formDataMapping'
import { updateProspect } from 'utils/apiRequest'

const Section = withOnboardingSection(PersonalInformationForm)

let prevPageInfo = {
  name: 'Getting Started',
  to: '/onboarding/getting_started',
  showBackWord: true
}

const submitAction = (formData) => {
  const submitData = {
    ...formData,
    reviewedPersonalInformation: true,
  }
  return updateProspect(submitData)
}

const PersonalInformation = (props) => {
  const {
    goOnboardingIdentityVerification,
    hide,
    isMobile,
    setProspect,
    prospect,
    isLoading
  } = props

  const setupData = () => {
    const formData = { ...prospect }
    const { personHomePhone, personMobilePhone } = formData

    if (personHomePhone === personMobilePhone) { 
      formData.homeSameAsMobile = true
    }

    return formData
  }

  const data = setupData()

  const { onboardingFinancialAccountsVisible } = prospect

  if (onboardingFinancialAccountsVisible) {
    prevPageInfo = {
      name: 'About You',
      to: '/onboarding/about_you',
      showBackWord: true
    }
  }

  return (
    <Section
      formName="Personal Information"
      description={['Let’s start with the basics.']}
      goNextSection={goOnboardingIdentityVerification}
      hide={hide}
      isMobile={isMobile}
      data={data}
      prevPageInfo={prevPageInfo}
      mapValues={mapPersonalInformationValues}
      setData={setProspect}
      isLoading={isLoading}
      submitAction={submitAction} />
  )
}

PersonalInformation.propTypes = {
  goOnboardingIdentityVerification: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  prospect: PropTypes.object.isRequired,
  setProspect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
}

export default PersonalInformation



// WEBPACK FOOTER //
// ./src/components/Onboarding/PersonalInformation/PersonalInformation.jsx